const moment = require('moment')
const {getNormilizeDate} = require("./getNormilizeDate");

export const getDays = (date_from, date_to, calcDays = false) => {
    const from = calcDays ? moment(getNormilizeDate(date_from, "en",'00:00:00')) : moment(getNormilizeDate(date_from, "en"))
    const to = calcDays ? moment(getNormilizeDate(date_to, "en",'23:59:59')) : moment(getNormilizeDate(date_to, "en"))
    if(!calcDays){
        return to.diff(from, "days");
    }else{
        const diff = to.diff(from, "minutes");
        return Math.round(diff / 60 / 24)
    }
};
